import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./lib/auth";
import { AppLayout } from "./components/layout/AppLayout";

// Marketing Pages
import { 
  HomePage, 
  AboutPage, 
  ServicesPage, 
  TrainingPage, 
  ContactPage, 
  PortalPage 
} from "./pages/marketing";

// EMR Pages
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardPage from "./pages/DashboardPage";
import PatientsPage from "./pages/PatientsPage";
import PatientDetailPage from "./pages/PatientDetailPage";
import PatientFormPage from "./pages/PatientFormPage";
import FormsPage from "./pages/FormsPage";
import FormBuilderPage from "./pages/FormBuilderPage";
import FormSubmitPage from "./pages/FormSubmitPage";
import SubmissionsPage from "./pages/SubmissionsPage";
import UsersPage from "./pages/UsersPage";
import SettingsPage from "./pages/SettingsPage";
import EventQuotePage from "./pages/EventQuotePage";
import ClinicalNotesPage from "./pages/ClinicalNotesPage";
import InvoicesPage from "./pages/InvoicesPage";
import EventQuotesManagePage from "./pages/EventQuotesManagePage";
import SchedulingPage from "./pages/SchedulingPage";
import PatientSummariesPage from "./pages/PatientSummariesPage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Marketing Website Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/training" element={<TrainingPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/portal" element={<PortalPage />} />
          
          {/* Legacy Public Routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/event-quote" element={<EventQuotePage />} />
          
          {/* Protected EMR Routes */}
          <Route path="/emr" element={<AppLayout />}>
            <Route index element={<Navigate to="/emr/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            
            {/* Patients */}
            <Route path="patients" element={<PatientsPage />} />
            <Route path="patients/new" element={<PatientFormPage />} />
            <Route path="patients/:id" element={<PatientDetailPage />} />
            <Route path="patients/:id/edit" element={<PatientFormPage />} />
            <Route path="patients/:patientId/clinical-notes" element={<ClinicalNotesPage />} />
            <Route path="patients/:patientId/invoices" element={<InvoicesPage />} />
            
            {/* Forms */}
            <Route path="forms" element={<FormsPage />} />
            <Route path="forms/builder" element={<FormBuilderPage />} />
            <Route path="forms/builder/:id" element={<FormBuilderPage />} />
            <Route path="forms/submit/:templateId" element={<FormSubmitPage />} />
            
            {/* Submissions */}
            <Route path="submissions" element={<SubmissionsPage />} />
            
            {/* Scheduling */}
            <Route path="scheduling" element={<SchedulingPage />} />
            
            {/* Patient Summaries */}
            <Route path="patient-summaries" element={<PatientSummariesPage />} />
            
            {/* Invoices */}
            <Route path="invoices" element={<InvoicesPage />} />
            
            {/* Event Quotes Management */}
            <Route path="event-quotes" element={<EventQuotesManagePage />} />
            
            {/* Users */}
            <Route path="users" element={<UsersPage />} />
            
            {/* Settings */}
            <Route path="settings" element={<SettingsPage />} />
          </Route>

          {/* Legacy routes redirect to EMR */}
          <Route path="/dashboard" element={<Navigate to="/emr/dashboard" replace />} />
          <Route path="/patients/*" element={<Navigate to="/emr/patients" replace />} />
          <Route path="/forms/*" element={<Navigate to="/emr/forms" replace />} />
          <Route path="/scheduling" element={<Navigate to="/emr/scheduling" replace />} />
          
          {/* Catch all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
